export const BASE_URL = '/auth';
export const AUTH_VALIDATE_CREDENTIALS_URL = `${BASE_URL}/validate-credentials`;
export const AUTH_LOGIN_URL = `${BASE_URL}/login`;
export const AUTH_INFO_SYNC_URL = `${BASE_URL}/info-sync`;
export const AUTH_FEATURE_USES_URL = `/auth/feature-uses/:featureCode`;

export const AUTH_V1_URL = `${BASE_URL}/v1`;
export const AUTH_V1_TOKEN_URL = `${AUTH_V1_URL}/token`;
